









































import { Component, Prop, Vue } from 'vue-property-decorator';
import { BvModalEvent, BvModal } from 'bootstrap-vue';
import { IProgram, ICourse, isCourse } from '../Scripts/ISearchService';
import { SendService } from '../Scripts/SendService';
import { Validator, IRuleViolation, IDispatcherResult } from '../Scripts/Validation';

import ActionTracker, { CloseRmiEvent, SendRmiEvent } from '../Scripts/AnalyticsEvents';
import { mapGetters } from 'vuex';
import { Getters } from '../store';

@Component({
	computed: {
		...mapGetters({
			applicationName: Getters.applicationName
		})
	}
})
export default class RequestMoreInfo extends Vue {
	@Prop() public item!: IProgram | ICourse;

	private wasValidated = false;
	private email = '';
	private name = '';
	private note = '';
	private busy = false;
	private messages: IRuleViolation[] = [];

	get title (): string {
		return this.item ? this.item.title : '';
	}

	get inst (): string {
		return this.item ? this.item.institutionName : '';
	}

	get emailState (): boolean | null {
		if (!this.wasValidated) {
			return null;
		}

		return Validator.isEmail(this.email);
	}

	get nameState (): boolean | null {
		if (!this.wasValidated) {
			return null;
		}
		const len = this.name.length;

		return len > 2 && len <= 50;
	}

	get noteState (): boolean | null {
		if (!this.wasValidated) {
			return null;
		}

		return this.note.length <= 255 ? null : false;
	}

	private resetModal (): void {
		this.busy = false;
		this.wasValidated = false;
		this.name = '';
		this.email = '';
		this.note = '';
		this.messages = [];
	}

	private cancel (): void {
		ActionTracker.track(new CloseRmiEvent(this.item, this.$router));
		this.resetModal();
	}

	private async handleOk (event: BvModalEvent): Promise<void> {
		// Prevent modal from closing
		event.preventDefault();

		this.wasValidated = true;
		this.messages = [];

		const valid = this.nameState && this.emailState && this.noteState !== false;

		if (valid) {
			ActionTracker.track(new SendRmiEvent(this.item, this.$router));

			this.busy = true;

			const sender = new SendService();

			let response:IDispatcherResult;

			if (isCourse(this.item)) {
				response = await sender.sendCourseRequest({
					courseId: this.item.id,
					name: this.name,
					emailAddress: this.email,
					note: this.note
				});
			} else {
				response = await sender.sendProgramRequest({
					programId: this.item.id,
					name: this.name,
					emailAddress: this.email,
					note: this.note
				});
			}
			this.busy = false;

			if (response.status === 200) {
				this.$nextTick(() => {
					// TODO:TRS Do not know how to do this without any
					// eslint-disable-next-line
					const rmi = (this.$refs.rmi as any) as BvModal;
					rmi.hide('');
				});
			} else {
				this.messages = response.failureMessages;
			}
		}
	}
}
